import moment from 'moment'
import 'moment/locale/ko'

export const getPeriod = (start, end, type) => {
  let period = []
  let betweenNum = moment(end).diff(moment(start), 'days') + 1

  for (let i = 0; i < betweenNum; i++) {
    period.push(
      moment(start)
        .add(i, 'd')
        .format(type ?? 'M.D'),
    )
  }

  return period
}
